import { formatDateToUTC2 } from "./date";

const formatFirstFormDataForPDF = (formattedData, selectedProject) => {
  formattedData[0].elements[0].value = selectedProject?.nameSurname || "";
  formattedData[0].elements[1].value = selectedProject?.vocation || "";
  formattedData[0].elements[2].value = selectedProject?.department?.name || "";
  formattedData[0].elements[3].value = selectedProject?.email || "";

  formattedData[1].elements[0].value = selectedProject?.projectTitle || "";
  formattedData[1].elements[1].value =
    selectedProject?.projectTitleEnglish || "";
  formattedData[1].elements[2].value = selectedProject?.projectAcronym || "";
  formattedData[1].elements[3].value =
    formatDateToUTC2(selectedProject?.applicationDeadline) || "";

  formattedData[2].elements[0].value = selectedProject?.projectSummary || "";
  formattedData[3].elements[0].value = selectedProject?.applicationURL || "";
  formattedData[4].elements[0].value = selectedProject?.projectApplicant || "";
  formattedData[5].elements[0].value = selectedProject?.projectPartners || "";

  formattedData[6].elements[0].value =
    `${selectedProject?.totalValue} EUR` || "";
  formattedData[6].elements[1].value =
    `${selectedProject?.fesbValuePart} EUR` || "";

  formattedData[7].elements[0].value =
    selectedProject?.newEmploymentBoolean ?? "vrijednost nije zadana";

  formattedData[8].elements[0].newEmploymentPositions =
    selectedProject?.newEmploymentPositions?.length > 0
      ? selectedProject?.newEmploymentPositions
      : "nema";
  formattedData[8].elements[0].title = "NOVA RADNA MJESTA";

  formattedData[9].elements[0].projectTeam =
    selectedProject?.projectTeam?.length > 0
      ? selectedProject?.projectTeam
      : "nema";

  return formattedData;
};

export default formatFirstFormDataForPDF;
